import { useEffect, useState } from 'react';
import { useAuth } from './AuthProvider';

export function AuthCallback() {
  const { session, loading, configured } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const description =
      search.get('error_description') ||
      search.get('error') ||
      hash.get('error_description') ||
      hash.get('error');
    if (description) setError(description.replace(/\+/g, ' '));
  }, []);

  useEffect(() => {
    if (session) window.location.replace('/app');
  }, [session]);

  return (
    <main className="auth-gate">
      <div className="auth-gate-card">
        <h1>{error ? 'Google sign-in did not finish' : 'Signing you in…'}</h1>
        <p>{error || (configured && loading ? 'Please wait a moment.' : 'Connecting your Google account.')}</p>
        <div className="auth-gate-actions">
          <a className="button button-primary" href="/app">Go to dashboard</a>
        </div>
      </div>
    </main>
  );
}
